
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.539 17.598a.3.3 0 01-.3.3H3.015a.3.3 0 01-.3-.3v-.918a.3.3 0 01.078-.203l3.798-4.141c.56-.624.956-1.143 1.19-1.559.24-.42.36-.842.36-1.263 0-.554-.157-1.001-.471-1.342-.31-.341-.727-.512-1.255-.512-.629 0-1.116.192-1.463.576-.292.324-.461.749-.507 1.274a.321.321 0 01-.312.3H2.79a.285.285 0 01-.29-.3c.039-.59.195-1.126.47-1.61a3.354 3.354 0 011.382-1.327c.602-.314 1.295-.471 2.078-.471 1.13 0 2.02.285 2.67.855.655.565.982 1.348.982 2.35 0 .58-.165 1.19-.495 1.83-.325.634-.86 1.356-1.606 2.166l-2.846 3.045h5.103a.3.3 0 01.3.3v.95zM13.12 17.898a.3.3 0 01-.3-.3V6.562a.3.3 0 01.3-.3h3.137c1.028 0 1.94.229 2.733.687a4.68 4.68 0 011.855 1.95c.437.842.655 1.806.655 2.893v.584c0 1.103-.221 2.072-.663 2.909a4.598 4.598 0 01-1.879 1.934c-.81.453-1.74.68-2.789.68H13.12zm1.722-10.006v8.392h1.32c1.06 0 1.872-.33 2.437-.991.57-.666.86-1.62.871-2.861v-.648c0-1.263-.274-2.227-.823-2.893-.55-.666-1.346-.999-2.39-.999h-1.415z"}})])
          )
        }
      }
    